import { useState, useEffect, useRef } from 'react';
import { Grid, Input, InputAdornment } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import * as clipboard from 'clipboard-polyfill/text';

// @Utility
import { setStorage, removeStorage } from "./../../../../../../../@utility/app/storage";
import alertText from "./../../../../../../../@utility/app/alertText";
import validateInput from "./../../../../../../../@utility/app/validateInput";

// auth
import { isUserLoggedIn } from "./../../../../../../../@core/auth/utils";

//  CSS
import styles from "./../../../../assets/css/Style.module.css";
import modalStyles from "./../../../../assets/css/Modal.module.css";
import buttonStyles from "./../../../../assets/css/Button.module.css";

// Services
import {
    confirmDeposit,
    loadDepositFirst,
    cancenDeposit,
    confirmStep,
    checkDeposit
} from "./../../../../../../../@core/services/depositService";
import { selectPromotionList } from "./../../../../../../../@core/services/promotionService";

// Redux
// import { openAuthenApp } from "./../../../../../../../@core/redux/actions/auth/index";
// import { setDataCondition } from "./../../../../../../../@core/redux/actions/app/conditions";
import { setStatusSpinner } from "./../../../../../../../@core/redux/actions/app/spinner";
import { setDepositData } from "./../../../../../../../@core/redux/actions/deposit/index";
import { setDataAlert } from "./../../../../../../../@core/redux/actions/app/alert";
// import { openPromotionPopup } from "./../../../../../../../@core/redux/actions/promotion/index";

// Component
// import LoadContent from "./../../../../components/LoadContent";
import SnackbarSet from "./../../../../components/SnackbarSet";
import Condition from "./../../component/Condition";
import BankSelect from "./BankSelect";
import BoxResult from "./BoxResult";

// Icons
// import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';


export default function FormDeposit({ typePage, bankList, depositItems, selectBank, setSelectBank, channelInfo }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const childRef = useRef();
    const [money, setMoney] = useState(0);
    const [promotionItem, setPromotionItem] = useState(null);
    const reduxPromotionPopup = useSelector(state => state.reduxPromotion);
    let snackbarJson = {};

    const checkTypePage = () => {
        return channelInfo?.name;
    }

    // const openCondition = () => {
    //     let myJson = {
    //         statusShow: true,
    //         title: "เติมเงิน",
    //         contentType: "deposit"
    //     };

    //     dispatch(setDataCondition(myJson));
    // };

    const confirmTrasaction = () => {
        if (isUserLoggedIn()) {
            if (selectBank === 0 || selectBank === "0") {
                snackbarJson = {
                    statusShow: true,
                    statusAlert: "warning",
                    titleAlert: "แจ้งเตือน",
                    textAlert: "กรุณาเลือกบัญชีเติมเงิน! ก่อนทำรายการ"
                };

                openBox(snackbarJson);
            }
            else if (money === 0) {
                snackbarJson = {
                    statusShow: true,
                    statusAlert: "warning",
                    titleAlert: "แจ้งเตือน",
                    textAlert: "กรุณาระบุจำนวนที่ต้องการเติมเงิน !"
                };

                openBox(snackbarJson);
            }
            else {
                if (depositItems.mode !== "pay") {
                    if (money >= channelInfo?.min_balance && money <= channelInfo?.max_balance) {
                        dispatch(setStatusSpinner({ status: true, textProcess: "ระบบกำลังขอเลขบัญชี กรุณารอสักครู่" }));

                        let myJson = {
                            amount: money,
                            bankId: selectBank,
                            typePage: typePage,
                            channel: channelInfo.key,
                            channelId: channelInfo.id,
                            channelPlatform: channelInfo.platform
                        };

                        confirmDeposit(myJson).then((data) => {
                            const statusCode = data.code;
                            dispatch(setStatusSpinner({ status: false, textProcess: null }));

                            if (statusCode === 200 || statusCode === 0) {
                                dispatch(setDepositData(data.result));
                                setStorage("processDeposit", data.result.id);

                                history.push(`/deposit/form/${data.result.method}`);
                            }
                            // else if (statusCode === 36) {
                            //     reloadData();
                            // }
                            else {
                                if (statusCode === 2 || statusCode === 4) {
                                    snackbarJson = alertText(statusCode);
                                    openBox(snackbarJson);

                                    setTimeout(function () {
                                        window.location.href = `/`;
                                    }, 5000);
                                }
                                else {
                                    snackbarJson = alertText(statusCode);
                                    openBox(snackbarJson);
                                }
                            }
                        });
                    }
                    else {
                        if (money < channelInfo?.min_balance) {
                            snackbarJson = {
                                statusShow: true,
                                statusAlert: "warning",
                                titleAlert: "แจ้งเตือน",
                                textAlert: `ยอดเติมเงินเริ่มต้นที่ ${channelInfo?.min_balance} บาท`
                            };

                            openBox(snackbarJson);
                        }

                        if (money > channelInfo?.max_balance) {
                            snackbarJson = {
                                statusShow: true,
                                statusAlert: "warning",
                                titleAlert: "แจ้งเตือน",
                                textAlert: `ยอดเติมเงินสูงสุด ${channelInfo?.max_balance} บาท`
                            };

                            openBox(snackbarJson);
                        }
                    }
                }
            }
        }
    };

    const confirmNextStep = () => {
        dispatch(setStatusSpinner({ status: true, textProcess: "ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่" }));
        let selectPromotion = 0;

        if (reduxPromotionPopup.promotionSelect) {
            selectPromotion = reduxPromotionPopup.promotionId
        }
        else {
            selectPromotion = 0;
        }

        let myJson = {
            td_id: depositItems.id,
            promotion_status: selectPromotion === 0 ? false : true,
            promotion_condition_id: selectPromotion
        };

        confirmStep(myJson).then((data) => {
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                if (data.result !== null) {
                    if (data.result.status === 2) {
                        snackbarJson = {
                            statusShow: true,
                            statusAlert: "success",
                            titleAlert: "แจ้งเตือน",
                            textAlert: "ทำรายการเติมเงินสำเร็จ !"
                        };

                        openBox(snackbarJson);

                        reloadData("home");
                    }
                    else {
                        reloadData();
                    }
                }
                else {
                    reloadData();
                }
            }
            else {
                alertWarning(statusCode);
            }
        });
    };

    const openBox = (snackbarJson) => {
        dispatch(setDataAlert({
            type: snackbarJson.statusAlert,
            title: snackbarJson.titleAlert,
            text: snackbarJson.textAlert,
            action: true,
            redirect: null,
            show: true,
            buttonText: "ตกลง"
        }));
    };

    const reloadData = (page) => {
        loadDepositFirst().then((data) => {
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                dispatch(setDepositData(data.result));
                setStorage("processDeposit", data.result.id);

                if (page === "home") {
                    history.push("/");
                }
                else {
                    history.push("/deposit/pending/manual");
                }
            }
            else {
                if (statusCode === 2 || statusCode === 4) {
                    snackbarJson = alertText(statusCode);
                    childRef.current.snackbar(snackbarJson);

                    setTimeout(function () {
                        window.location.href = `/`;
                    }, 5000);
                }
                else {
                    snackbarJson = alertText(statusCode);
                    childRef.current.snackbar(snackbarJson);
                }
            }
        });
    };

    const cancelTransaction = () => {
        dispatch(setStatusSpinner({ status: true, textProcess: null }));

        cancenDeposit().then((data) => {
            const statusCode = data.code;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                snackbarJson = {
                    statusShow: true,
                    statusAlert: "success",
                    titleAlert: "แจ้งเตือน",
                    textAlert: "ยกเลิกรายการเติมเงินสำเร็จ !"
                };

                removeStorage("processDeposit");
                openBox(snackbarJson);
                reloadData("home");
            }
            else {
                alertWarning(statusCode);
            }
        });
    };

    const alertWarning = (statusCode) => {
        if (statusCode === 2 || statusCode === 4) {
            snackbarJson = alertText(statusCode);
            openBox(snackbarJson);

            setTimeout(function () {
                window.location.href = `/`;
            }, 5000);
        }
        else {
            snackbarJson = alertText(statusCode);
            openBox(snackbarJson);
        }
    };

    const loadPromotionData = (amount) => {
        selectPromotionList(amount).then((data) => {
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                setPromotionItem(data.result === null ? [] : data.result);
            }
            else {
                setPromotionItem([]);
            }
        });
    };

    const resetNumber = () => {
        if (money === 0) {
            setMoney("");
        }
    };

    const checkTransaction = (checkTime) => {
        checkDeposit(depositItems.id).then((data) => {
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                switch (data.result.status) {
                    case 0:
                    case 1: break;
                    case 2:
                        snackbarJson = {
                            statusShow: true,
                            statusAlert: "success",
                            titleAlert: "แจ้งเตือน",
                            textAlert: "ทำรายการเติมเงินสำเร็จ !"
                        };

                        openBox(snackbarJson);

                        clearInterval(checkTime);
                        removeStorage("processDeposit");
                        reloadData("home");
                        break;
                    case 3:
                        snackbarJson = {
                            statusShow: true,
                            statusAlert: "error",
                            titleAlert: "แจ้งเตือน",
                            textAlert: "ทำรายการเติมเงินไม่สำเร็จ ! กรุณาติดต่อผู้ดูแลระบบ"
                        };

                        openBox(snackbarJson);

                        clearInterval(checkTime);
                        removeStorage("processDeposit");
                        reloadData("/");
                        break;
                    default:
                        clearInterval(checkTime);
                        removeStorage("processDeposit");
                        break;
                }
            }
            else {
                if (statusCode === 2 || statusCode === 4) {
                    snackbarJson = alertText(statusCode);
                    openBox(snackbarJson);

                    setTimeout(function () {
                        window.location.href = `/`;
                    }, 5000);
                }
                else {
                    snackbarJson = alertText(statusCode);
                    openBox(snackbarJson);
                }
            }
        });
    };

    useEffect(() => {
        if (isUserLoggedIn()) {
            if (depositItems !== null) {
                if (depositItems.mode === "pay") {
                    let amountData = parseInt(depositItems.amount);
                    setMoney(amountData);
                    loadPromotionData(amountData);
                }
            }
        }
    }, [depositItems]);

    useEffect(() => {
        if (depositItems !== null) {
            if (depositItems.mode === "pay") {
                let timer = depositItems.time, minutes, seconds;
                let countTime = 0;
                const checkTime = setInterval(() => {
                    minutes = parseInt(timer / 60, 10);
                    seconds = parseInt(timer % 60, 10);

                    minutes = minutes < 10 ? "0" + minutes : minutes;
                    seconds = seconds < 10 ? "0" + seconds : seconds;

                    // setTimeShow(`${minutes} : ${seconds}`);
                    if (--timer < 0) {
                        // setTimeShow(0);
                        clearInterval(checkTime);
                        return null;
                    }
                    else {
                        countTime++;
                        if (countTime === 3) {
                            checkTransaction(checkTime);
                            countTime = 0;
                        }
                    }

                }, 1000);

                return () => {
                    clearInterval(checkTime);
                }
            }
        }
    }, [depositItems]);

    return (
        <>
            <SnackbarSet ref={childRef} />

            <div className={modalStyles.boxTitle}>
                {checkTypePage()}
            </div>

            {
                depositItems !== null && (
                    <BankSelect isUserLoggedIn={isUserLoggedIn()} bankList={bankList} depositItems={depositItems} typePage={typePage} selectBank={selectBank} setSelectBank={setSelectBank}></BankSelect>
                )
            }

            {
                depositItems !== null && (
                    depositItems.mode === "deposit" && (
                        bankList !== null && bankList.length > 0 && (
                            <div id="DepositInput" className={[styles.inputBorder, styles.boxMarginMediumTop].join(" ")}>
                                <div className={styles.textBankMoney} style={{ color: "white" }}>
                                    จำนวนเงิน :
                                </div>
                                <Grid container alignItems="center" style={{ marginTop: "-8px" }} spacing={1}>
                                    <Grid item xs={8} md={9}>
                                        <div className={[styles.inputMoneyMargin, "center"].join(" ")}>
                                            <Input
                                                id="money"
                                                variant="standard"
                                                fullWidth
                                                type="number"
                                                pattern="[0-9]*"
                                                color="secondary"
                                                className={[styles.bankTitile, styles.yellow, styles.inputAdornment, styles.transactionInput].join(" ")}
                                                placeholder="ระบุจำนวนเงิน"
                                                value={money}
                                                style={{ borderBottom: "1px solid white" }}
                                                onKeyPress={(event) => validateInput(event, "numberDecimal")}
                                                onChange={(e) => { setMoney(e.target.value) }}
                                                onClick={() => { resetNumber() }}
                                                endAdornment={<InputAdornment position="end"><div className={[styles.bankTitile, styles.white, styles.inputAdornment].join(" ")} >บาท</div></InputAdornment>}
                                            ></Input>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} md={3}>
                                        <div id={`deposit_${channelInfo?.key}_${channelInfo?.mode}`} className={buttonStyles.btnReqBank} onClick={confirmTrasaction}>
                                            ขอเลขบัญชี
                                        </div>
                                    </Grid>
                                </Grid>
                                <div className={styles.textBankMoney} style={{ marginTop: "4px", fontSize: "14px" }}>
                                    ยอดเริ่มต้น {channelInfo?.min_balance} สูงสุด {channelInfo?.max_balance} บาท
                                </div>
                            </div>
                        )
                    )
                )
            }

            <div className={styles.boxMarginFormTop}>
                {
                    depositItems !== null && (
                        depositItems.mode === "pay" ?
                            <BoxResult
                                depositItems={depositItems}
                                openBox={openBox}
                                promotionItem={promotionItem}
                                reduxPromotionPopup={reduxPromotionPopup}
                            ></BoxResult>
                            :
                            <div className={styles.boxBankAgentBorder}>
                                <Condition typePage={typePage} condition={channelInfo?.condition}></Condition>
                            </div>
                    )
                }
            </div>

            {
                depositItems !== null && (
                    depositItems.mode === "pay" && (
                        <div className={styles.boxMarginFormTop}>
                            <div className="center">
                                <button className={[buttonStyles.btnRedirect, buttonStyles.btnConfirm].join(" ")} onClick={confirmNextStep}>
                                    ยืนยันการโอนเงิน
                                </button>
                            </div>
                            <br />
                            <div className="center">
                                <button className={[buttonStyles.btnConfirm, buttonStyles.btnCancel].join(" ")} onClick={cancelTransaction}>
                                    ยกเลิกเติมเงิน
                                </button>
                            </div>
                        </div>
                    )
                )
            }
        </>
    );
}